export default "__VITE_ASSET__BjvHsqkP__"